
import { updatePrecustomer } from "../redux/features/precustomers/PrecustomerSlice"; // Ensure the correct import path

export const handleContinueOnboarding = (data, dispatch, navigate, type) => {
  const { id: preCustomerId, msisdn, isSelfOnboard } = data;
  const onboardingStatus = data.onboardingStatus?.toUpperCase();
  const bvn = data.kyc_infos?.find(info => info.inputName === "Bvn")?.inputValue;
  const nin = data.kyc_infos?.find(info => info.inputName === "Nin")?.inputValue;
  const accountNumber = data.kyc_infos?.find(info => info.inputName === "AccountNumber" || info.inputName === "account_number"|| info.inputName === "accountNumber")?.inputValue;
  const idNumber = data.kyc_infos?.find(info => info.inputName === "id_number")?.inputValue;  
  const email = data.kyc_infos?.find(info => info.inputName === "Email")?.inputValue;  
  const bankName = data.kyc_infos?.find(info => info.inputName === "BankName")?.inputValue;
  const accountName = data.kyc_infos?.find(info => info.inputName === "AccountName")?.inputValue;
  const employmentStatus = data.kyc_infos?.find(info => info.inputName === "EmploymentStatus")?.inputValue;
  const employerName = data.kyc_infos?.find(info => info.inputName === "NameOfEmployer")?.inputValue;
  const salaryAmount = data.kyc_infos?.find(info => info.inputName === "SalaryAmount")?.inputValue;
  const salaryDate = data.kyc_infos?.find(info => info.inputName === "SalaryDate")?.inputValue;
  const bundled_device_type_id = data.kyc_infos?.find(info => info.inputName === "bundled_device_type_id")?.inputValue;
  const eligibleAmount = data.kyc_infos?.find(info => info.inputName === "EligibleAmount")?.inputValue;
  const creditLimit = data.kyc_infos?.find(info => info.inputName === "credit_limit")?.inputValue;

  const updateAndNavigate = (status, route) => {
    if (
      dispatch(
        updatePrecustomer({
          precustomer: {
            precustomerId: preCustomerId,
            msisdn: msisdn,
            bvn: bvn,
            nin: nin,
            accountNumber: accountNumber,
            idNumber: idNumber,
            email: email,
            bankName : bankName,
            accountName : accountName,
            employmentStatus : employmentStatus,
            employerName : employerName,
            salaryAmount : salaryAmount,
            salaryDate : salaryDate,
            bundled_device_type_id: bundled_device_type_id,
            eligibleAmount : eligibleAmount,
            creditLimit : creditLimit,
          },
          onboarding_status: status,
        })
      )
    ) {
      navigate(route);
    }
  };

  switch (onboardingStatus) {
    case "OTP-SENT":
    case "OTP SENT":
    case "OTP_SENT":
    case "OTP SENT.":
      if(type === "oxygen") {
        updateAndNavigate( "validate-otp-oxygen", "/oxygenForm-OTP" );
      }else if(type === "FBN"){
        updateAndNavigate("validate-otp", "/validate-otp");
      }else if(type === "AODF2"){
        updateAndNavigate("validate-otp-aodf2", "/aodf2Form-OTP");
      }
      break;
    case "OTP_VALIDATED":
    case "OTP VALIDATED.":
    case "OTP VALIDATED. ":
    case "OTP VALIDATED":
      if(type === "oxygen") {
        updateAndNavigate( "validate-otp-oxygen", "/oxygenForm-OTP" );
      }else if(type === "FBN"){
        updateAndNavigate("oxygen-device-bundles", "/fbn-device-bundles");
      }else if(type === "AODF2"){
        updateAndNavigate("oxygen-device-bundles", "/oxygen-device-bundles");
      }
      break;
    case "ELIGIBILITY_PASS":
      updateAndNavigate("oxygen-device-bundles", "/oxygen-device-bundles");
      break;
    case "BUNDLE_SELECTED":
    case "BUNDLE_SELECTED.":
      if(type === "AODF2"){
        updateAndNavigate("kyc", "/kyc");
      }else{
        updateAndNavigate("liveness-check", "/liveness-check");
      }
      break;
    case "LIVENESS_CHECK":
    case "LIVENESS_CHECK.":
      updateAndNavigate("bundletandc" , "/bundletandc");
      break;
    case "TERMS_CONDITIONS":
    case "TERMS_CONDITIONS.":
      if(type === "AODF2"){
        updateAndNavigate("bundletandc", "/aodfTandC");
      }else{
        updateAndNavigate("kyc", "/kyc");
      }
      break;
    case "PENDING":
      updateAndNavigate("kyc", "/kyc");
      break;
    case "KYC_SUBMIT":
    case "KYC_SUBMIT.":
    case "KYC_Submitted":
    case "KYC_SUBMITTED.":
    case "KYC_SUBMITTED":
      if (isSelfOnboard === true) {
        updateAndNavigate("kyc", "/kyc");
      } else {
        updateAndNavigate("kyc", "/kyc");
      }
      break;
    
    case "LOAN_APPROVED":
    case "LOAN_APPROVED ":
    case "LOAN_APPROVED.":
    case "LOAN APPROVED":
      if(type === "FBN" ) {
        updateAndNavigate("oxygenpayment-links", "/fbnpayment-link");
      }else if(type === "oxygen"){
        updateAndNavigate("oxygenpayment-links", "/oxygenpayment-links");
      }
      break;
    case "APPROVED":
      if (isSelfOnboard === true) {
        updateAndNavigate("kyc", "/kyc");
      } else {
        if(type === "FBN" || type === "oxygen" || type === "AODF2") {
          updateAndNavigate( "kyc", "/kyc" );
      }
      }
      break;
    case "NOK_OTP_VALIDATED":
    case "NOK_OTP_VALIDATED.":
      if(type === "AODF2") {
        updateAndNavigate( "sideload", "/sideload" );
      }else if (type === "FBN" || type === "oxygen"){
        updateAndNavigate("kyc", "/nextOfKin-OTP");
      }
      break;
    case "KYC_APPROVED":
    case "QR_CODE":
      updateAndNavigate("sideload", "/sideload");
      break;
    case "RELEASE_DEVICE":
      updateAndNavigate("deviceRelease", "/deviceRelease");
      break;
    case "CUSTOMER-PROFILED":
    case "CUSTOMER-ONBOARDED":
      updateAndNavigate("customer-profiled", "/status/onboarded");
      break;
    default:
      navigate("/prequalify");
  }
};
